import React from 'react';
import { CloseIcon } from '../Icons/iconImages';
import type { ToastOptions } from 'react-toastify';

interface CustomToastProps {
  closeToast?: () => void;
  title: string | { error: string };
  message?: string;
  type?: ToastOptions['type'];
}

const CustomToast: React.FC<CustomToastProps> = ({
  closeToast,
  title,
  message,
  type = 'default',
}) => {
  let titleMessage: string | undefined;
  let titleString: string | undefined;
  if (typeof title !== 'string') {
    titleMessage = (title as { error: string })?.error;
    titleString = 'Error';
  } else {
    titleString = title;
  }

  return (
    <div className="relative bg-white rounded-xl shadow-lg p-3 sm:p-4 min-w-[160px] sm:min-w-[200px] max-w-[320px] sm:max-w-[400px] border border-[#D5D7DA] mb-2">
      {titleString && (
        <p
          className={`font-semibold text-xs sm:text-sm ${type === 'error' || type === 'warning'
            ? 'text-[#D92D20]'
            : 'text-[#181D27]'
          } pr-5 sm:pr-6`}
        >
          {titleString}
        </p>
      )}
      {(titleMessage || message) && (
        <p className="text-xs sm:text-sm text-gray-800">{titleMessage || message}</p>
      )}
      {/* Close Button */}
      <button
        onClick={closeToast}
        className="absolute top-3 right-3 sm:top-4 sm:right-4 text-gray-600"
      >
        <CloseIcon className="w-2.5 h-2.5 sm:w-3 sm:h-3" />
      </button>
    </div>
  );
};

export default CustomToast;
